module.exports = __webpack_public_path__ + "img/Ben Hill Station Concepts_Page_1.58d5055b.jpg";